import DeleteIcon from '@mui/icons-material/Delete'
import { Button, type ButtonProps } from '@mui/material'

function DeleteButton({ children, ...restProps }: ButtonProps) {
  return (
    <Button color="error" startIcon={<DeleteIcon />} {...restProps}>
      {children}
    </Button>
  )
}
export default DeleteButton
